module.exports = __webpack_public_path__ + "static/1-9af99c245c2eeea4bffdf3b132151f7c.png";